/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./ListCards.css";
import ListCardsCardItem from "./component/ListCardsCardItem";
import { simpleFetch } from "../../restWrapper";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { renderErrorMsg } from "../../assets/component/renderErrorMsg.js";
import errorMsg from "../../assets/json/errMsg.json";

class ListCards extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...this.props.location.state,
      cards: [],
      loading: true,
      errorMsg: "",
    };

    this._deleteCard = this._deleteCard.bind(this);
  }

  _deleteCard(paymentMethodId, last4) {
    if (this.state.loading) return;

    const languageObj = this.props.languageObj;
    const confirmMsg = (languageObj.removeConfirm || "Remove this card ({last4})?").replace(
      "{last4}",
      last4
    );
    const isConfirm = window.confirm(confirmMsg);
    if (!isConfirm) return;

    this.setState({ loading: true, errorMsg: "" });

    simpleFetch("/cards/delete", "POST", {
      paymentMethod: paymentMethodId,
    })
      .then((res) => {
        if (res.status === 200) {
          return simpleFetch("/cards", "GET").then((cardsRes) => {
            if (!cardsRes || cardsRes.status !== 200) {
              window.location.reload();
              return;
            }
            this.setState({
              cards: cardsRes.body,
              loading: false,
              errorMsg: "",
            });
          });
        }

        this.setState({
          loading: false,
          errorMsg:
            languageObj.removeScheduledError ||
            "Please note this card is associated with one of the scheduled payments. To remove this card, please make sure no scheduled payments are associated with this card.",
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
          errorMsg:
            (errorMsg[this.props.language] && errorMsg[this.props.language].fail) ||
            "Please try again later.",
        });
      });
  }

  componentDidMount() {
    simpleFetch("/cards", "GET").then((res) => {
      if (!res || res.status !== 200) {
        const language = this.props.language;
        const fallbackError =
          (errorMsg[language] && errorMsg[language].fail) ||
          "Please try again later.";
        this.setState({
          cards: { data: [] },
          loading: false,
          errorMsg: fallbackError,
        });
        return null;
      }
      this.setState({
        cards: res.body,
        loading: false,
        errorMsg: "",
      });
      return null;
    }).catch((error) => {
      const language = this.props.language;
      const fallbackError =
        (errorMsg[language] && errorMsg[language].fail) ||
        "Please try again later.";
      // console.error("Error fetching cards:", error);
      this.setState({
        cards: { data: [] },
        loading: false,
        errorMsg: fallbackError,
      });
    });

    simpleFetch("/donors", "GET").then((res) => {
      if (res.status !== 200) return res.status;
      let dataObj = res.body;
      let donorInfo = {
        firstName: dataObj.firstName,
        lastName: dataObj.lastName,
        email: dataObj.username,
      };
      if (dataObj.phoneNumber) donorInfo.phoneNumber = dataObj.phoneNumber;

      this.setState({
        ...this.state,
        ...{
          donorInfo,
        },
      });
      return res;
    });
  }

  render() {
    if (this.state.loading) {
      return <this.props.RenderFullPageLoading />;
    }

    if (!this.props.location.state || !this.props.location.state.color) {
      return null;
    }

    const donorInfo = this.state;

    const languageObj = this.props.languageObj;

    const color = this.props.location.state.color;

    const organizationName = this.props.location.state.organizationName;

    const backgroundOverrideStyle = {
      background: "#" + this.props.location.state.color.headerColor,
    };

    return (
      <div className="ListCards-view">
        <Helmet>
          <title>{organizationName}</title>
        </Helmet>
        <div className="ListCards-bg" style={backgroundOverrideStyle} />
        <div className="ListCards-cardsContainer">
          <div className="ListCards-header">
            <div className="ListCards-headingText">
              {languageObj.headingText}
            </div>

            <Link to="/SelectMission">
              <div className="ListCards-backContainer">
                <div className="ListCards-back">
                  <div className="ListCards-backBtn"></div>
                  <div className="ListCards-backText">
                    {languageObj.backBtn}
                  </div>
                </div>
              </div>
            </Link>

            <Link
              to={{
                pathname: "/AddCard",
                state: {
                  ...donorInfo,
                  color: color,
                  organizationName: organizationName,
                },
              }}
            >
              <div className="ListCards-addContainer">
                <div className="ListCards-add" />
              </div>
            </Link>
          </div>

          {renderErrorMsg(this.state.errorMsg)}

          <RenderCards
            cards={this.state.cards}
            color={color}
            languageObj={languageObj}
            onDeleteCard={this._deleteCard}
          />
        </div>
      </div>
    );
  }
}

const RenderCards = (props) => {
  const cardData = props.cards.data;
  if (!cardData) return null;
  return (
    <div className="ListCards-cards">
      {cardData.map((item) => (
        <ListCardsCardItem
          key={item.id || item}
          data={item}
          color={props.color}
          languageObj={props.languageObj}
          onDeleteCard={props.onDeleteCard}
        />
      ))}
    </div>
  );
};

ListCards.propTypes = {
  language: PropTypes.string,
  languageObj: PropTypes.object,
};

RenderCards.propTypes = {
  cards: PropTypes.object,
  color: PropTypes.object,
  languageObj: PropTypes.object,
  onDeleteCard: PropTypes.func,
};

export default ListCards;
